import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Insurer.Save.IRequest;
type Response = Api.Core.Insurer.Save.IResponse;
type Headers = Api.Core.Insurer.Save.IHeaders;
const url = '/api/ProductManagement/Insurer';
export default async function insurerSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
